import C from "@/components/sidebar/StandardSidebar.module.css";

import { PriceWithDiscount } from "@/components/PriceWithDiscount.tsx";
import type { Price } from "@/modules/pricing/resourcePricing.ts";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

interface PriceBlockProps {
    price: Price;
    title?: ReactNode;
    prefix?: string;
    billingAccountId?: number;
}

export function PriceBlock({ prefix, title, ...props }: PriceBlockProps) {
    return (
        <div className={C.StandardBlockInfo}>
            {title ? (
                title
            ) : (
                <div className="text-muted">
                    <Trans>Monthly cost</Trans>
                </div>
            )}
            {!!prefix && <>{prefix} </>}
            <PriceWithDiscount allowFree {...props} />
        </div>
    );
}
